import { imageDataToDataUrl, imgToImageData, urlToImageData } from './module';

export class Mat {
    imageData:ImageData;
    
    constructor(imageData:ImageData) {
        this.imageData = imageData;
    }

    static ready() {
        return true;
    }

    static validType(mat: Mat) {
        return Object.getPrototypeOf(mat) == Mat.prototype;
    }

    static createFromSize(width: number, height: number) {
        const imageData = new ImageData(width, height);
        return imageData ? new Mat(imageData) : null;
    }

    static async createFromUrl(url: string) {
        const imageData = await urlToImageData(url);
        return imageData ? new Mat(imageData) : null;
    }

    static async createFromImg(imgElement: HTMLImageElement) {
        var imageData = await imgToImageData(imgElement);
        return imageData ? new Mat(imageData) : null;
    }

    delete() {
        // @ts-ignore
        delete this.imageData;
    }

    empty() {
        return !this.imageData;
    }

    data() {
        return this.imageData.data;
    }

    width() {
        return this.imageData.width;
    }

    height() {
        return this.imageData.height;
    }

    channels() {
        return 4;
    }

    async toDataUrl() {
        return await imageDataToDataUrl(this.imageData);
    }
    
}
